export const adminConfig = {
  allowSettingsTabForUsers: true,  // Can be changed to false to disable Settings tab for non-admins
  adminUsers: [
    'maximilian.leimgruber.admin@provectus-lab.de',
    'maximilian.leimgruber@provectus.de',
    // Add more admin emails as needed
  ]
};

export const isAdminUser = (userEmail: string): boolean => {
  return adminConfig.adminUsers.includes(userEmail?.toLowerCase());
}; 